import type { ClientType, IClient, ICollection } from '@/interfaces'
import { addressClass, contactClass, type FieldType } from '@/interfaces'
import { ClientAddress, ClientContact, ClientKPIs, ClientProperties, Collection } from '@/models'

import { addToJSON } from './helper'

export class Client implements IClient {
	[key: string]: FieldType
	id: number | string
	name?: string
	type: ClientType
	active: boolean
	updateDate?: Date
	federalTaxID?: string
	addresses: ICollection<ClientAddress>
	contacts: ICollection<ClientContact>
	currency: string
	phone1?: string
	phone2?: string
	fax?: string
	mobile?: string
	email?: string
	web?: string
	notes?: string
	paymentTerms: number
	ownerCode?: number
	salesTeam: number
	firstInvoiceDate?: string
	storageAgreement?: string
	clientExtendedProperties: ClientProperties
	clientKPI: ClientKPIs

	constructor({
		id = 'Code not assigned yet...',
		name,
		type,
		active,
		updateDate,
		federalTaxID,
		addresses,
		contacts,
		currency = '$',
		phone1,
		phone2,
		fax,
		mobile,
		email,
		web,
		notes,
		paymentTerms = 3,
		ownerCode,
		salesTeam = 0,
		firstInvoiceDate,
		storageAgreement,
		clientExtendedProperties,
		clientKPI
	}: Partial<IClient> = {}) {
		this.id = id
		this.name = name
		this.type = type || 'Lead'
		this.active = active || true
		this.updateDate = updateDate
		this.federalTaxID = federalTaxID
		this.addresses = new Collection(ClientAddress, addresses || [])
		this.contacts = new Collection(ClientContact, contacts || [])
		this.currency = currency
		this.phone1 = phone1
		this.phone2 = phone2
		this.fax = fax
		this.mobile = mobile
		this.email = email
		this.web = web
		this.notes = notes
		this.paymentTerms = paymentTerms
		this.ownerCode = ownerCode
		this.salesTeam = salesTeam
		this.firstInvoiceDate = firstInvoiceDate
		this.storageAgreement = storageAgreement
		this.clientExtendedProperties = new ClientProperties(clientExtendedProperties)
		this.clientKPI = new ClientKPIs(clientKPI)
		addToJSON(Client)
	}

	get activeStatus(): string {
		return this.active ? 'Active' : 'Inactive'
	}

	public resetContact(newContact: ClientContact, oldContact: ClientContact) {
		this.contacts.reset(newContact, oldContact)
	}

	public resetAddress(newAddress: ClientAddress, oldAddress: ClientAddress) {
		this.addresses.reset(newAddress, oldAddress)
	}

	public changePrimaryContact(contact: ClientContact) {
		this.contacts.forEach((c) => {
			if (c.id === contact.id) {
				c.contactClass = contactClass.Primary
			} else {
				c.contactClass = contactClass.Other
			}
		})
	}

	public changePrimaryAddress(address: ClientAddress) {
		this.addresses.forEach((a) => {
			if (a.type === address.type) {
				if (a.id === address.id) {
					a.addressClass = addressClass.Primary
				} else {
					a.addressClass = addressClass.Other
				}
			}
		})
	}

	toJSON(): string {
		// this will be overridden by the addToJSON method
		return ''
	}
}
